<script>
export default {
  components: {},
  props: {
    google: { type: Object, required: true },
    map: { type: Object, required: true },
    graphicCircle: { type: Object, required: false },
  },
  data() {
    return {
      nombre_asociado: this.graphicCircle.nombre_asociado,
      id_asociado: this.graphicCircle.id_asociado,
      etiqueta: this.graphicCircle.etiqueta,
      fecha: this.graphicCircle.fecha,
      tipo: this.graphicCircle.tipo,
      id_sig_subobjeto: this.graphicCircle.id_sig_subobjeto,
      color: this.graphicCircle.color,
      circle: {},
      id: this.graphicCircle.id,
      center: this.graphicCircle.center,
      radius: this.graphicCircle.radius,
      label: this.graphicCircle.label,
      aplicacionesCliente: this.graphicCircle.aplicacionesCliente,
      marker: null,
    };
  },
  mounted() {
    this.crearCirculo();
  },

  watch: {
    graphicCircle: function () {
      let idAnterior = this.id;
      this.id = this.graphicCircle.id;
      this.center = this.graphicCircle.center;
      this.radius = this.graphicCircle.radius;
      this.label = this.graphicCircle.label;
      this.aplicacionesCliente = this.graphicCircle.aplicacionesCliente;
      this.color = this.graphicCircle.color;
      this.nombre_asociado = this.graphicCircle.nombre_asociado;
      this.id_asociado = this.graphicCircle.id_asociado;
      this.etiqueta = this.graphicCircle.etiqueta;
      this.fecha = this.graphicCircle.fecha;
      this.tipo = this.graphicCircle.tipo;
      this.id_sig_subobjeto = this.graphicCircle.id_sig_subobjeto;

      if (this.id != idAnterior) {
        this.borrarCirculo();
        this.crearCirculo();
      }
    },
    color: function () {
      this.circle.setOptions({
        strokeColor: this.color,
        fillColor: this.color,
      });
    },
    label: function () {
      var label = this.marker.getLabel();
      label.text = this.label;
      this.marker.setLabel(label);

      this.$store.commit("aplicaciones/cambiarEtiqueta", {
        id_sig_subobjeto: this.id_sig_subobjeto,
        etiqueta: this.label,
      });
    },
  },
  methods: {
    crearCirculo() {
      //<----Calcular  area y pintarla ----->
      this.circle = new google.maps.Circle({
        map: this.map,
        center: this.center,
        id: this.id,
        radius: this.radius,

        //diseño
        strokeColor: this.color,
        strokeOpacity: 1,
        strokeWeight: 2,
        fillColor: this.color,
        fillOpacity: 0.9,
      });

      const marker = new google.maps.Marker({
        position: this.center,
        map: this.map,
        icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 0
        },
        label: {
          color: "#fff",
          fontWeight: "bold",
          text: this.label,
          fontSize: "10pt",
        },
      });

      //guardar marcador
      this.marker = marker;

      this.marker.addListener("click", (graphicCircle) => {
        this.agregarAplicacionesStore();
      });

      this.circle.addListener("click", (graphicCircle) => {
        this.agregarAplicacionesStore();
      });
    },

    borrarCirculo() {
      this.marker.setMap(null);
      this.circle.setMap(null);
    },

    agregarAplicacionesStore() {
      let dataEnviar = {
        aplicacionesNodo: this.aplicacionesCliente,
        etiquetaNodo: this.label,
        idNodo: this.id,
        nombre_asociado: this.nombre_asociado,
        id_asociado: this.id_asociado,
        etiqueta: this.etiqueta,
        fecha: this.fecha,
        tipo: this.tipo,
        id_sig_subobjeto: this.id_sig_subobjeto,
        color: this.color,
      };

      this.$store.commit("aplicaciones/borrarAplicaciones");
      this.$store.commit("aplicaciones/actualizarAplicaciones", dataEnviar);
    },
  },

  destroyed() {
    this.borrarCirculo();
  },

  render() {},
};
</script>
